import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IGroomerStaffDetailResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useConfigurationGroomerStaffDetailAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const accessTokenKey = configuration.localStorage.ACCESS_TOKEN.key;

  const execute = useCallback(
    async (groomerId: string) => {
      if (!groomerId) return null;
      try {
        const accessToken = localStorage.getItem(accessTokenKey);
        const url = `${CONFIGURATION_APIS.GROOMER_STAFF_DETAIL.baseURL}${groomerId}/`;
        const response = await axios.get<IGroomerStaffDetailResponse>(url, {
          headers: {
            Authorization: `${accessToken}`,
            Accept: "application/json",
          },
        });
        return response.data?.data ?? null;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
        toast.error("Unable to fetch groomer details");
        return null;
      }
    },
    [accessTokenKey],
  );

  return { execute };
};
